export const CairoPlayTitle: React.FC<{
  title: string
}> = ({ title }) => (
  <h2
    style={{
      whiteSpace: 'break-spaces',
      textAlign: 'center',
      fontFamily: 'CairoPlay',
    }}
  >
    {title}
  </h2>
)
